import React, { useEffect, useRef } from "react";

export function createMachineName(str = "") {
  return str
    .replace(/([A-z])/gi, (v) => v.toLowerCase())
    .replace(/\s/gi, "-")
    .replace(/([^A-z-_])/gi, "");
}

export default function InfiniteScrollHeader({ text = "", id = "" }) {
  const ref = useRef();
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          history.replaceState(
            undefined,
            undefined,
            `#${createMachineName(text)}`
          );
          dispatchEvent(new PopStateEvent("popstate", {}));
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 1,
      }
    );
    if (ref?.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref?.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);
  return (
    <div>
      <h2 ref={ref} id={createMachineName(text)}>
        {text.replace(/&nbsp;/g, " ")}
      </h2>
    </div>
  );
}
